import { FadeUp } from "@/components/Reveal";

const sections = [
  {
    title: "The service",
    body: "ApiaryKeeper is a pre-launch beekeeping record-keeping platform operated by Herrell Interactive (Herrell Homestead LLC). The website and launch list are provided as-is while the product is in beta.",
  },
  {
    title: "Launch list",
    body: "Joining the launch list reserves your place for early access and founding-member pricing communications. It does not create a subscription, charge, or obligation of any kind.",
  },
  {
    title: "Founding Keeper rates",
    body: "Founding Keeper locked rates apply to the first 100 claimed spots, as shown by the site counter, and remain in effect for as long as the associated subscription stays active. Rates are honored at launch when subscriptions become available.",
  },
  {
    title: "Referral rewards",
    body: "BeeCredits™ earned through the referral program have no cash value and can be applied toward ApiaryKeeper subscriptions and features as described at launch. Rewards are issued only for qualified referrals per the program rules shown on the site, and we may adjust or end the program with notice.",
  },
  {
    title: "Acceptable use",
    body: "Don't misuse the referral program (self-referrals, fake signups, spam). We may void rewards and remove signups that abuse the program.",
  },
  {
    title: "Contact",
    body: "Questions about these terms: support@apiarykeeper.com. ApiaryKeeper is a product of Herrell Interactive (Herrell Homestead LLC).",
  },
];

export default function Terms() {
  return (
    <section className="max-w-3xl mx-auto px-6 py-16 md:py-24" data-testid="terms-page">
      <FadeUp>
        <p className="text-xs uppercase tracking-[0.3em] text-honey-dark mb-6">Legal</p>
        <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tighter text-forest mb-4" data-testid="terms-heading">
          Terms of Service
        </h1>
        <p className="text-sm text-ink/40 mb-12">Last updated: August 2026</p>
      </FadeUp>
      <div className="flex flex-col gap-10">
        {sections.map((s, i) => (
          <FadeUp key={s.title} delay={i * 0.05}>
            <div className="border-t border-forest/15 pt-6" data-testid={`terms-section-${i + 1}`}>
              <h2 className="font-display text-2xl text-forest mb-3">{s.title}</h2>
              <p className="text-ink/60 leading-relaxed text-sm md:text-base">{s.body}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
